var $root_nav_desktop = $('.root-nav.desktop');

function menuViewMore($menus, item_selector, count) {
    if (count === undefined) {
        count = 5;
    }

    for (var i = 0; i < $menus.length; i++) {
        var $block = $($menus[i]);
        var $links = $block.find(item_selector).not('.more');
        var $view_more = $block.find('.view-more');


        if ($links.length <= count + 1 || $menus.length < 2) {
            $view_more.remove();
        } else {
            var detached = [];

            for (var j = 0; j < $links.length; j++) {
                var $link = $($links[j]);

                if (j > count - 1) {
                    detached.push($link.detach());
                }
            }

            $view_more.show();
            var $rest = $('<ul class="rest"></ul>');
            $rest.hide();

            $rest.append(detached);
            $view_more.after($rest);
            $view_more.on('click', function (e) {
                e.preventDefault();
                var $this = $(this);
                $this.stop(true).fadeOut({
                    duration: 250,
                    easing: 'easeInOutQuint',
                    complete: function () {
                        $this.parent().find('.rest').slideDown({
                            duration: 250,
                            easing: 'easeInOutQuint'
                        });
                    }
                });
            });
        }
    }
}

menuViewMore($('.footer-nav nav'), 'ul li', 4);

function desktopMenuViewMore() {
    var $sub_navs = $root_nav_desktop.find('.sub-nav');

    for (var k = 0; k < $sub_navs.length; k++) {
        var $sub_nav = $($sub_navs[k]);
        var $rnav_blocks = $sub_nav.find('.sub-nav-block');

        if ($rnav_blocks.length === 1) {
            $sub_nav.addClass('only-one-block');
}

        if (!$rnav_blocks.length) {
            $sub_nav.addClass('no-blocks');
        }

        menuViewMore($rnav_blocks, '.link-wrap li');
    }
}
desktopMenuViewMore();

var $root_nav_mobile = null;

function mobileMenuBuilder() {
    var $mobile_nav_footer = $('footer.main').clone(true);
    $mobile_nav_footer.removeAttr('role');
    $mobile_nav_footer.removeClass('blur').addClass('copy');
    $mobile_nav_footer.find('.desktop').remove();
    $mobile_nav_footer.find('.newsletter').remove();
    var $mobile_nav = $('<div id="menu-pane" aria-label="Menu" data-hook="menu" class="menu pane mobile"><a class="hamburger close-button" aria-label="Close" role="button" tabindex="0"><span class="top"></span><span class="mid"></span><span class="bot"></span></a><div class="pane-content"></div></div>');

    var $root_navs = $root_nav_desktop.find('.root-nav-item');

    $root_nav_mobile = $('<ul class="root-nav mobile" />')
    $root_nav_mobile.append('<li class="back space nav-item"></li>');

    for (var i = 0; i < $root_navs.length; i++) {
        var $root_nav_item = $($root_navs[i]);
        var $temp = $root_nav_item.clone();
        $temp.find('.sub-nav').remove();

        var $subs = $root_nav_item.find('.sub-nav-block');
        var $sub_shift = $root_nav_item.find('.sub-shift');

        if ($subs.length > 0) {
            $temp.addClass('has-sub');
            var $temp_second = $('<ul class="sub-nav second" />');
            $temp_second.append('<li class="back nav-item"><button>' + $temp.find('button').text() + '</button></li>');

            if ($subs.length > 1) {
                for (var j = 0; j < $subs.length; j++) {
                    var $sub = $($subs[j]);
                    var title = $sub.find('small.title').text();
                    var title_slug = slug(title);
                    var $temp_link = $('<li class="has-sub nav-item"><button data-href="#' + title_slug + '">' + title + '</button></li>');
                    var $links = $sub.find('.link-wrap a, .rest a').clone();

                    var $temp_third = $('<ul class="sub-nav third" />');
                    $temp_third.append('<li class="back nav-item"><button>' + title + '</button></li>');
                    $temp_third.append($links);
                    $links.wrap('<li class="nav-item"></li>');

                    $temp_link.append($temp_third);
                    $temp_second.append($temp_link);
                }
            } else {
                var $links = $subs.find('.link-wrap a, .rest a').clone();
                $temp_second.append($links);
                $links.wrap('<li class="nav-item"></li>');
            }
            $temp.append($temp_second);
        } else if ($subs.length === 0 && $sub_shift.length) {
            $temp.addClass('has-sub');
            var $temp_second = $('<ul class="sub-nav second" />');
            $temp_second.append('<li class="back nav-item"><button>' + $temp.find('button').text() + '</button></li>');

            var $links = $sub_shift.find('a').clone();
            $temp_second.append($links);
            $links.wrap('<li class="nav-item"></li>');

            $temp.append($temp_second);
        }

        $root_nav_mobile.append($temp);
    }


    $mobile_nav.find('.pane-content').append($root_nav_mobile);
    $root_nav_mobile.wrap('<div class="core-menu" />');
    $mobile_nav.find('.pane-content').append($mobile_nav_footer);
    $('#search-pane').before($mobile_nav);

    $root_nav_mobile.find('.nav-item.has-sub > button').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $sub = $(this).parent().find('.sub-nav').first();
        $('.core-menu').height($sub.height());
        $sub.addClass('active');
    });

    $root_nav_mobile.find('.nav-item.back > button').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $sub = $(this).parent().parent();
        $('.core-menu').height($sub.parent().parent().height());
        $sub.removeClass('active');
        setTimeout(function () {
            $sub.css('visibility', 'hidden');
        }, 250);
    });
}
mobileMenuBuilder();

$root_nav_desktop.find('.root-nav-item > button').on('click', function (e) {
    e.preventDefault();
    var $this = $(this).parent();
    var $sub = $this.find('.sub-nav');
    var $other = $this.parent().find('.root-nav-item').not($this);
    var $active = $this.parent().find('.root-nav-item.active').not($this);

    if (!$this.hasClass('active')) {
        if ($active.length) {
            $active.find('.sub-nav').removeClass('open');
            $active.find('.sub-nav').stop(true).hide();
            $active.removeClass('active');
        }

        $other.addClass('opaque');

        $this.removeClass('opaque');
        $this.addClass('active');
        $('body').addClass('desktop-menu-open');
        $('#menu-underlay').stop(true).fadeIn({
            duration: 250,
            easing: 'easeInOutQuint'
        });

        $sub.addClass('open');
        $sub.stop(true).fadeIn({
            duration: 250,
            easing: 'easeInOutQuint'
        });
        disableScroll();
    } else {
        $other.removeClass('opaque');

        $this.removeClass('active');

        $('body').removeClass('desktop-menu-open');

        $sub.removeClass('open');
        $sub.stop(true).fadeOut({
            duration: 250,
            easing: 'easeInOutQuint'
        });

        $('#menu-underlay').stop(true).fadeOut({
            duration: 250,
            easing: 'easeInOutQuint'
        });

        enableScroll();
    }
});

$('#menu-underlay').on('click', function () {
    
    var $links = $root_nav_desktop.find('.root-nav-item');
    $links.removeClass('opaque active');
    var $sub = $links.find('.sub-nav');
    $('body').removeClass('desktop-menu-open');
    $sub.removeClass('open');

    $sub.stop(true).fadeOut({
        duration: 250,
        easing: 'easeInOutQuint'
    });

    $(this).stop(true).fadeOut({
        duration: 250,
        easing: 'easeInOutQuint'
    });

    enableScroll();
});

var $underlay = $('#underlay');
var $search_pane = $('#search-pane');
var $cart_pane = $('#cart-pane');
var $menu_pane = $('#menu-pane');

var $search_button = $('#search-button');
var $cart_button = $('#cart-button');
var $search_bar = $('#search-bar');
//var $hamburger_close = $('.hamburger.close-button');
var $hamburger_menu = $('#hamburger_menu');
var $controls = $('header#main .control');
var $controlMobileMenu = $('header#main .control.mobile-menu');
var controls_timer = null;
var controlMenuOpenTimer = 10; 
var controlMenuCloseTimer = 500;

$(document).ready(function() { // Because animation is not working on iphone
    controlMenuOpenTimer = isMobileScreen() ? 200 : 10;
    controlMenuCloseTimer = isMobileScreen() ? 50 : 500;
});

var closePane = {};
closePane.search = function () {
    $search_button.removeClass('active');
    $search_bar.find('input').trigger('blur');
}

closePane.cart = function () {
//    $controls.removeClass('hide');
//    $controls.css('z-index', 1);

    if (controls_timer) {
        clearTimeout(controls_timer);
        controls_timer = null;
    }
}

function closePanes(pane) {

    if ($search_pane.hasClass("active")) {
        $search_button.focus();
    } else if ($cart_pane.hasClass("active")) {
        $cart_button.focus();
    } else if ($menu_pane.hasClass("active")) {
        $hamburger_menu.focus();
    }

    $('body').removeClass('search-open cart-open menu-open');
    
    $('.pane').removeClass('active');
    
    setTimeout(function() { // Hide this pane after animation is completed
        $('.pane').hide();
    }, controlMenuCloseTimer);
    
    $controls.removeClass('hide');
    
    if(isMobileScreen()) {
       $controls.css('z-index', 10);
    }

    if (pane) {
        closePane[pane]();
    } else {
        for (var k in closePane) {
            closePane[k]();
        }
    }

    $underlay.stop(true).fadeOut({
        duration: 250,
        easing: 'easeInOutQuint'
    });
    
//    $hamburger_close.removeClass('active');
//    $hamburger_close.attr("tabindex", "-1");
//    $hamburger_close.unbind('keydown');
    
    if(isMobileScreen()) {
        $controlMobileMenu.removeClass('hide');
//        $controls.css('z-index', 1);
    }
    
    enableScroll();
}

function openSearch() {
    
    if($search_pane.is(":visible")) { // already open or opening before closing same pane
        console.log("Pane already open");
        return true;
    }

    $search_pane.show();
    
    setTimeout(function(){ // timeout is required for animation
        $search_pane.addClass('active');
    }, controlMenuOpenTimer);
    
    if(isMobileScreen()) {
        $controls.addClass('hide');
        $controls.css('z-index', -1);
        
        // Check whether menu is already opened
        if($("#menu-pane").hasClass("active")) {
            $("#menu-pane").removeClass("active")
        }
    }
    
    $('body').addClass('search-open');
    $underlay.stop(true).fadeIn({
        duration: 250,
        easing: 'easeInOutQuint'
    });
    $search_button.addClass('active');
    $search_bar.find('input').trigger('focus');
    
//    $hamburger_close.addClass('active');
//    $hamburger_close.attr("tabindex", 0);
    
    disableScroll();

    $search_button.removeClass("focused-by-tab");
    handleSearchViewFocus();
}

function openCart() {
    
    if($cart_pane.is(":visible")) { // already open or opening before closing same pane
        console.log("Pane already open");
        return true;
    }
   
    $cart_pane.show();
    
    setTimeout(function(){ // timeout is required for animation
        $cart_pane.addClass('active');
    }, controlMenuOpenTimer);
    
    if(isMobileScreen()) {
        $controls.addClass('hide');
        $controls.css('z-index', -1);
        
        // Check whether menu is already opened
        if($("#menu-pane").hasClass("active")) {
            $("#menu-pane").removeClass("active")
        }
    }
    
    $('body').addClass('cart-open');
    
//    controls_timer = setTimeout(function () {
//        $controls.css('z-index', -1);
//    }, 250)
    
    $underlay.stop(true).fadeIn({
        duration: 250,
        easing: 'easeInOutQuint'
    });
    
//    $hamburger_close.addClass('active');
//    $hamburger_close.attr("tabindex", 0);
//    $hamburger_close.focus();
    
    disableScroll();

    // Get ready to focus
    //$("#cart-pane").find(".cart-title").focus();
    handleCartViewFocus();
}

function openMenu() {
    
    if($menu_pane.is(":visible")) { // already open or opening before closing same pane
        console.log("Pane already open");
        return true;
    }
    
//    $controls.addClass('hide');
    $controlMobileMenu.addClass('hide');
    $controlMobileMenu.css("z-index", -1);
    
    $menu_pane.show();

    setTimeout(function(){ // timeout is required for animation
        $menu_pane.addClass('active');
    }, controlMenuOpenTimer);
        
    $('body').addClass('menu-open');
    
    $underlay.stop(true).fadeIn({
        duration: 250,
        easing: 'easeInOutQuint'
    });
    
//    $hamburger_close.addClass('active');
//    $hamburger_close.attr("tabindex", 0);
//    $hamburger_close.focus();
    
    handleMobileMenuViewFocus();
    disableScroll();
}

function orderlyPaneClose() {    
    var $panes = $('.pane');
    var $active_panes = $('.pane.active');

    if ($active_panes.length > 1) {
        for (var i = $panes.length - 1; i >= 0; i--) {
            var $pane = $($panes[i]);

            if ($pane.hasClass('active')) {
                var hook = $pane.data('hook');
                $('body').removeClass(hook + '-open');

                if (closePane.hasOwnProperty(hook)) {
                    closePane[hook]();
                }

                $pane.removeClass('active');
                break;
            }
        }
    } else {
        closePanes();
    }    
}

$('a.hamburger.close-button').on('click', function () {
    
    $('.search-has-items').css('display','none');
    
    $('.empty').css({"display":"block","opacity":"1"});
    $('#search').val('');
//    if ($(this).hasClass('active')) {
//     location.reload();
        orderlyPaneClose();       
//    }
});

$(document).keydown(function(e) {   
    // ESCAPE key pressed
    if (e.keyCode == 27) {
        $('.empty').css({"display":"block","opacity":"1"});
        $('#search').val('');
        $('.stat').css("display","none");
//        $('.pane-items').css("display","none");
//        setTimeout("window.location.reload(true);", 1000);
        orderlyPaneClose();        
    }
});

$hamburger_menu.on('click', function () {
    openMenu();
});

$underlay.on('click', function(){
    
//    location.reload();
    //setTimeout("window.location.reload(true);", 1000);
    $('.empty').css({"display":"block","opacity":"1"});
    $('#search').val('');
    $('.stat').css("display","none");
//    $('.pane-items').css("display","none");
    orderlyPaneClose();
    
});

$('header#main .control.cart').on('click', openCart);

var searchVal = '';

$search_button.on('click', function () {

    searchVal = $('.search-bar #search').val();
    searchVal = searchVal.trim();

    if (searchVal == '') {
        openSearch();
//                                return false;
    }
    if (searchVal != '' && searchVal.length > 2) {
//                            alert('searchVal2...'+searchVal);
        if ($(this).parent().hasClass('active')) {
            $(this).parent().find('.search-bar button').trigger('click');
        } else {
            openSearch();
        }
    } else if (searchVal != '' && searchVal.length < 2) {
        alert('Enter Valid Search...');
        openSearch();
    }

});

$('footer small.title').on('click', function () {
    var $this = $(this);
    if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.parent().find('ul').stop(true).slideUp({
            duration: 250,
            easing: 'easeInOutQuint'
        });
    } else {
        $this.addClass('active');
        $this.parent().find('ul').stop(true).slideDown({
            duration: 250,
            easing: 'easeInOutQuint'
        });
    }
});

function disableScroll() {
    iNoBounce.enable();
    _disableScroll();

    if (window.scroll_width !== undefined && window.scroll_width) {
        $('header#main nav .root-nav.desktop li .sub-nav').css({
                "width": 'calc(100% + ' + scroll_width + 'px)'
        });
}
}

function enableScroll() {
    _enableScroll();
    iNoBounce.disable();
}

